
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const courseOptions = [
  "Web Development", "Graphic Designing" , "Dom Excel" , "Forex Trading", "Digital Marketing",
  "Data Science", "Spoken English", "UI/UX Designing", "Python Programming"
];

export default function AddStudent({ studentData = null, onSuccess }) {
  const [formData, setFormData] = useState({
    studentName: '', fatherName: '', birthDate: '', gender: '', division: '',
    district: '', address: '', phone1: '', phone2: '', email: '',
    occupation: '', status: '', courseName: '', image: null,
  });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (studentData) {
      setFormData({ ...studentData, image: null });
    }
  }, [studentData]);

  const handleChange = e => {
    const { name, value, files } = e.target;
    if (name === "image") setFormData(prev => ({ ...prev, image: files[0] }));
    else setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSelectCourse = course => {
    setFormData(prev => ({ ...prev, courseName: course }));
    setIsDropdownOpen(false);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const data = new FormData();
      for (let key in formData) data.append(key, formData[key]);
      data.set("status", "Pending"); // always pending for new enrollment

      if (studentData && studentData._id) {
        await axios.put(`https://expertb.codebyte.live/api/updateStudent/${studentData._id}`, data);
        toast.success("Student updated successfully!");
      } else {
        await axios.post('https://expertb.codebyte.live/api/addstudent', data);
        toast.success("Enrollment submitted! Wait for approval.");
      }

      setFormData({
        studentName: '', fatherName: '', birthDate: '', gender: '', division: '',
        district: '', address: '', phone1: '', phone2: '', email: '',
        occupation: '', status: '', courseName: '', image: null,
      });

      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
      toast.error("Failed to submit student.");
    }
  };

  return (
    <div className="relative min-h-screen bg-white text-red-600 p-4 sm:p-6">
      <div className="max-w-6xl mx-auto shadow-xl rounded-xl p-4 sm:p-6 bg-white relative z-10">
        <div className="relative z-10 flex flex-col md:flex-row justify-between mb-6 md:mb-8 gap-6">
          <h1 className="text-2xl md:text-3xl font-bold">
            {studentData ? 'Update Student' : 'Admission Form'}
          </h1>

          <div className="flex flex-col items-center border-2 border-dashed border-red-300 rounded-lg p-4 w-full sm:w-60 bg-white z-10">
            <div className="w-24 h-24 rounded-full bg-gray-100 overflow-hidden flex items-center justify-center mb-2">
              {formData.image ? (
                <img src={URL.createObjectURL(formData.image)} alt="Preview" className="object-cover w-full h-full" />
              ) : (
                <span className="text-xs text-gray-500">No Image</span>
              )}
            </div>
            <label className="text-sm font-medium mb-1">Choose Profile Pic</label>
            <input type="file" name="image" accept="image/*" onChange={handleChange} className="text-xs" />
          </div>
        </div>

        <form onSubmit={handleSubmit} className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-4">
          <input name="studentName" value={formData.studentName} placeholder="Student Name" onChange={handleChange} className="input" />
          <input name="fatherName" value={formData.fatherName} placeholder="Father Name" onChange={handleChange} className="input" />
          <input type="date" name="birthDate" value={formData.birthDate} onChange={handleChange} className="input" />

          <div className="flex items-center gap-4 border px-4 py-2 rounded-md">
            <label className="text-sm">Gender:</label>
            <label><input type="radio" name="gender" value="Male" onChange={handleChange} checked={formData.gender === 'Male'} /> Male</label>
            <label><input type="radio" name="gender" value="Female" onChange={handleChange} checked={formData.gender === 'Female'} /> Female</label>
          </div>

          <input name="division" value={formData.division} placeholder="Division" onChange={handleChange} className="input" />
          <input name="district" value={formData.district} placeholder="District" onChange={handleChange} className="input" />
          <input name="address" value={formData.address} placeholder="Address" onChange={handleChange} className="input" />
          <input name="phone1" value={formData.phone1} placeholder="Phone Number" onChange={handleChange} className="input" />
          <input name="phone2" value={formData.phone2} placeholder="Alternate Number" onChange={handleChange} className="input" />
          <input name="email" type="email" value={formData.email} placeholder="Email Address" onChange={handleChange} className="input" />
          <input name="occupation" value={formData.occupation} placeholder="Occupation" onChange={handleChange} className="input" />

          <div className="relative col-span-1 md:col-span-2">
            <button type="button" onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="input text-left">
              {formData.courseName || 'Select Course'}
            </button>
            {isDropdownOpen && (
              <ul className="dropdown absolute z-30 w-full mt-1 bg-white border rounded-md max-h-64 overflow-y-auto shadow-lg">
                {courseOptions.map(course => (
                  <li key={course} onClick={() => handleSelectCourse(course)} className="px-4 py-2 cursor-pointer hover:bg-red-100">{course}</li>
                ))}
              </ul>
            )}
          </div>

          <button type="submit" className="col-span-1 md:col-span-2 bg-red-600 text-white py-2 rounded-md hover:bg-red-700">
            {studentData ? 'Update' : 'Submit'}
          </button>
        </form>
      </div>

      <ToastContainer position="top-center" />

      <style>{`
        .input {
          padding: 0.5rem 1rem;
          border: 1px solid #ccc;
          border-radius: 0.375rem;
          outline: none;
          background: white;
          color: #b91c1c;
          width: 100%;
        }
        .input:focus {
          border-color: #b91c1c;
          box-shadow: 0 0 0 1px #b91c1c;
        }
        ::placeholder {
          color: #b91c1c;
        }
      `}</style>
    </div>
  );
}
